import React from "react";
import PaymentMethodSelector from "./PaymentMethodSelector";
import TapPayment from "./TapPayment";
import PaypalPayment from "./PaypyalPayment";

const PaymentProvider = ({
  formik,
  tapRef,
  onTokenizationSuccess,
  onTokenizationError,
  onTapReady,
  onCardValid,
  customer,
  transaction,
  interfaceConfig,
  showPaypal,
  children,
}) => {
  const handleProviderChange = (provider) => {
    formik.setFieldValue("payment_provider", provider);
    if (provider === "tap") {
      onTapReady(false);
    }
  };

  const selectedProvider = formik.values.payment_provider || "tap";
  return (
    <div className="payment-method">
      {/* {
        showPaypal && (
          <PaymentMethodSelector
            selectedProvider={selectedProvider}
            onProviderChange={handleProviderChange}
            showPaypal={showPaypal}
          />
        )
      } */}
      
      {selectedProvider === "tap" && (
        <TapPayment
          ref={tapRef}
          onTokenizationSuccess={onTokenizationSuccess}
          onTokenizationError={onTokenizationError}
          onReady={onTapReady}
          onCardValid={onCardValid}
          customer={customer}
          transaction={transaction}
          interfaceConfig={interfaceConfig}
        >
          {children}
        </TapPayment>
      )}

      {selectedProvider === "paypal" && showPaypal && (
        <PaypalPayment>
          {children}
        </PaypalPayment>
      )}
    </div>
  );
};

export default PaymentProvider;
